import React, { useContext } from 'react';
import { Segment } from 'semantic-ui-react';
import ThumbStat from '../../../projectSpecific/thumbstat/ThumbStat';
import { googleSheetsTypes } from '../../cnr/reducers/GoogleSheetsReducer';
import { clickOriginTypes, gEnums } from '../../enums/globalEnums';
import { CreateClientWithProvider } from '../../viewSettings/create/addSubs/CreateClient';
import { CreateEventWithProvider } from '../../viewSettings/create/addSubs/CreateEvent';
import DeleteEvent from '../../viewSettings/events/DeleteEvent';
import { allDataModes } from './AppDashboard';
import AppManifest from './AppManifest';
import SettingsAreaProvider from 'global/cnr/contexts/SettingsAreaContext';
import SettingsParentProvider from 'global/cnr/contexts/SettingParentContext';
import { NotificationsDashboard } from 'global/appNotifications/NotificationsDashboard';
import AppErrors from './AppErrors';
import { CacheDashboard } from './CacheDashboard';

const AppCheck = React.lazy(() => import('./AppCheck'));
const AppDatas = React.lazy(() => import('./AppDatas'));
const AppDataTransferWithProvider = React.lazy(() => import('../../pageItem/modification/dataModifications/AppDataTransfer'));
const AppDataViewer = React.lazy(() => import('./AppDataViewer'));
const AppDocuments = React.lazy(() => import('./AppDocuments'));
const AppFunctionSettings = React.lazy(() => import('../../pageItem/modification/dataModifications/AppFunctionSettings'));
const AppSettings = React.lazy(() => import('../../pageItem/modification/dataModifications/AppSettings'));
const AppUserManagement = React.lazy(() => import('../../appUsers/AppUserManagement'));
const DataConstraints = React.lazy(() => import('../../pageItem/modification/dataModifications/DataConstraints'));
const DataLinking = React.lazy(() => import('../../pageItem/modification/dataModifications/DataLinking'));
const DataMerge = React.lazy(() => import('../../pageItem/modification/dataModifications/DataMerge'));
const FileManagement = React.lazy(() => import('./FileManagement'));
const GoogleDashboardWithProvider = React.lazy(() => import('./GoogleDashboard'));
const GoogleFormsViewerWithProvider = React.lazy(() => import('./GoogleFormsViewer'));
const ImageMap = React.lazy(() => import('../swipe/ImageMapping'));
const ImageMapping = React.lazy(() => import('../swipe/ImageMapping'));
const LinkNotifications = React.lazy(() => import('../../pageItem/modification/dataModifications/LinkNotifications'));
const QuickView = React.lazy(() => import('./QuickView'));
const RegDashboard = React.lazy(() => import('../../wrappers/RegDashboard'));
const RegDataViewerWithProvider = React.lazy(() => import('./RegDataViewer'));
const StorageManagement = React.lazy(() => import('./StorageManagement'));
const TransferProvider = React.lazy(() => import('../../cnr/contexts/TransferContext'));
const UiMoveData = React.lazy(() => import('../../pageItem/modification/dataManagement/UiMoveData'));
const UiUpload = React.lazy(() => import('../../pageItem/modification/dataManagement/UiUpload'));

const AppDashboardContent = (props) => {

  const { currentDataMode, handleDataMode } = props ?? {}

  switch (currentDataMode) {

    case allDataModes.appData:
      return <AppDataViewer />

    case allDataModes.appErrors:
      return <AppErrors />

    case 'bulkImageUpload':
      return <UiUpload origin={'AppDashboardContent'} showUpload={true} />

    case allDataModes.appCheck:
      return <AppCheck />

    case allDataModes.appDatas:
      return <AppDatas />

    case allDataModes.appDocuments:
      return <AppDocuments />

    case allDataModes.appFunctionSettings:
      return <AppFunctionSettings />

    case allDataModes.appSettings:
      return <SettingsParentProvider>
        <SettingsAreaProvider vssProps={{}}>
          <AppSettings />
        </SettingsAreaProvider>
      </SettingsParentProvider>

    case allDataModes.appTransfer:
      return <AppDataTransferWithProvider clickOriginType={clickOriginTypes.dataViewer} appTransferMode={currentDataMode} handleCancel={handleDataMode} />

    case allDataModes.appUsers:
    case allDataModes.clientAppUsers:
    case allDataModes.clientProfiles:
      return <AppUserManagement clickOriginType={clickOriginTypes.dataViewer} handleCancel={handleDataMode} />

    case allDataModes.fileManagement:
      return <FileManagement />

    case allDataModes.storageManagement:
      return <StorageManagement />

    case allDataModes.googleDashboard:
      return <TransferProvider>
        <GoogleDashboardWithProvider googleSheetType={googleSheetsTypes.normal} clickOriginType={clickOriginTypes.dataViewer} />
      </TransferProvider>

    case allDataModes.cacheDashboard:
      return <CacheDashboard />

    case allDataModes.googleRegistration:
      return <TransferProvider>
        <GoogleFormsViewerWithProvider />
      </TransferProvider>

    case allDataModes.appManifest:
      return <AppManifest />

    case allDataModes.zoneMapping:
      return <ImageMap handleCancel={handleDataMode} imageMapType={gEnums.imageMapTypes.zoneMapping} inDashboard={true} />

    case allDataModes.testMode:
      return <ThumbStat />

    case allDataModes.regData:
      return <RegDashboard />

    case allDataModes.locationMapping:
      return <ImageMapping handleCancel={handleDataMode} imageMapType={gEnums.imageMapTypes.locationMapping} inDashboard={true} />

    case allDataModes.appNotifications:
      return <NotificationsDashboard />

    case allDataModes.import:
      return <Segment basic>Import</Segment>

    case allDataModes.quickView:
      return <QuickView />

    case allDataModes.createClient:
      return <CreateClientWithProvider />

    case allDataModes.createEvent:
    case allDataModes.recreateEvent:
      return <CreateEventWithProvider fromAppViewer={true} currentDataMode={currentDataMode} />

    case allDataModes.regDashboard:
      return <RegDashboard />

    case allDataModes.deleteEvent:
      return <DeleteEvent />

    case allDataModes.registrationData:
      return <RegDataViewerWithProvider clickOriginType={clickOriginTypes.dataViewer} handleCancel={handleDataMode} />

    case allDataModes.moveDataTo:
      return <UiMoveData dataMode={currentDataMode} />

    case allDataModes.linkData:
      return <DataLinking handleCancel={handleDataMode} />

    case allDataModes.linkNotifications:
      return <LinkNotifications handleCancel={handleDataMode} />

    case allDataModes.mergeData:
      return <DataMerge handleCancel={handleDataMode} />

    case allDataModes.dataConstraints:
      return <DataConstraints />

    default:
      return <div style={{ padding: '1em' }}>{'No component set up for ' + currentDataMode + '.'}</div>
    // nothing
  }
}

export default AppDashboardContent